// JWT Token Decoder Utility
// Extracts claims from JWT tokens without verification (frontend-only)

export interface JWTPayload {
  role?: string;
  email?: string;
  user_id?: string;
  nameid?: string;
  unique_name?: string;
  exp?: number;
  iat?: number;
  [key: string]: any;
}

export function decodeJWT(token: string): JWTPayload | null {
  try {
    // JWT format: header.payload.signature
    const parts = token.split('.');
    if (parts.length !== 3) {
      console.error('Invalid JWT format');
      return null;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    
    // Base64 decode (handle URL-safe base64)
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    
    // Parse JSON
    const parsed = JSON.parse(decoded);
    
    console.log('Decoded JWT payload:', parsed);
    return parsed;
  } catch (error) {
    console.error('Error decoding JWT:', error);
    return null;
  }
}

export function getRoleFromToken(token: string): string | null {
  const payload = decodeJWT(token);
  if (!payload) return null;
  
  // The backend sends role as a claim in the JWT
  const role = payload.role || payload.Role;
  console.log('Role from JWT:', role);
  
  return role || null;
}
